import axios from '@axios'

export const state = {
  shippings: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecord: 0,
}

export const getters = {
  allShippings: (state) => state.shippings,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecord: (state) => state.totalRecord,
}

export const mutations = {
  GET_SHIPPINGS: (state, resp) => {
    if (!resp) return null
    state.shippings = resp.shipping
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecord = resp.totalRecords
  },
  CREATE_SHIPPINGS: (state, shipping) => {
    shipping.id = new Date().getTime()
    state.shippings.push(shipping)
  },
  UPDATE_SHIPPINGS: (state, shipping) => {
    for (let i = 0; i < state.shippings.length; i++) {
      if (state.shippings[i].id === shipping.id) {
        shipping.id = new Date().getTime()
        for (let field in state.shippings[i]) {
          state.shippings[i][field] = shipping[field]
        }
        break
      }
    }
  },
  REMOVE_SHIPPINGS: (state, shipping) => {
    state.shippings = state.shippings.filter((m) => m.id !== shipping.id)
  },
}

export const actions = {
  async getShippings({ commit }, params) {
    await axios
      .get(`/api/shippings`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          let data = Object.assign({}, resp.data)
          commit('GET_SHIPPINGS', data)
        }
      })
      .catch(() => {
        commit('GET_SHIPPINGS', null)
      })
  },
  async createShippings({ commit }, shipping) {
    return axios.post('/api/shippings', shipping)
  },
  async updateShippings({ commit }, shipping) {
    return axios.put('/api/shippings', shipping)
  },
  async deleteShippings({ commit, dispatch }, shipping) {
    await axios.delete('/api/shippings', { data: shipping }).then((resp) => {
      if (resp.status === 204) {
        commit('REMOVE_SHIPPINS', shipping)
        let notification = {
          id: Date.now(),
          type: 'success',
          title: 'DELETE',
          message: 'The shipping has been deleted',
        }
        dispatch('notification/addNotification', notification, { root: true })
      }
    })
  },
}
